import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;

  flex-direction: column;

  height: calc(100vh - 56px);

  header {
    p {
      text-align: center;
      font-weight: 500;
      font-size: 17px;
      color: ${({ theme }) => theme.colors.mainDark};
    }
    background-color: ${({ theme }) => theme.colors.background};
    padding: 14px 0;
    width: 100%;
  }

  main {
    margin-top: 5%;
    height: 100%;
  }
`;
